import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";

function App() {
  return (
    <div className="App">
      <HomePage />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
